import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as artifactActions from '~/artifact/actions';
type ArtifactViewMainContentFixInfoSafeVersionsProps = {
  actions: object;
  artifactState: object;
};
class ArtifactViewMainContentFixInfoSafeVersions extends React.Component<
  ArtifactViewMainContentFixInfoSafeVersionsProps,
  {}
> {
  componentDidMount() {
    const { artifactState } = this.props;
    const { componentId: currentComponentId, artifact = {} } = artifactState;
    const { artifactComponents = [] } = artifact;
    const activeComponent =
      artifactComponents.find(component => component.componentId === currentComponentId) || {};
    const { versionRanges = [] } = activeComponent;
    const versionRange = (versionRanges[0] && versionRanges[0].versionRange) || '';
    // Load safe versions of the first version range of the active component
    if (currentComponentId && versionRange) {
      this.props.actions.fetchSafeVersionsAfterRange(currentComponentId, versionRange);
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    let oldStore = this.props.artifactState,
      newStore = nextProps.artifactState,
      oldActiveComponentId = oldStore.componentId,
      newActiveComponentId = newStore.componentId,
      activeRanges = newStore.vulnerableRangeByComponent || {},
      activeRange = activeRanges[newActiveComponentId] || {},
      activeVersionRange = activeRange.versionRange;
    if (oldActiveComponentId !== newActiveComponentId) {
      if (activeVersionRange) {
        this.props.actions.fetchSafeVersionsAfterRange(newActiveComponentId, activeVersionRange);
      }
    }
  }
  componentWillUnmount() {
    this.props.actions.resetSafeVersionsAfterRange();
  }
  updateActiveSafeVersion = e => {
    let version = e.target.value;
    this.props.actions.updateActiveSafeVersion(version);
  };
  render() {
    const { artifactState = {} } = this.props;
    const {
      safeVersionsAfterRange: safeVersions,
      isFetchingSafeVersionsAfterRange,
    } = artifactState;
    const self = this;
    let versionOptions = [];
    let activeSafeVersion = artifactState.activeSafeVersion;
    let versionsHtml;
    if (isFetchingSafeVersionsAfterRange) {
      activeSafeVersion =
        safeVersions && safeVersions.length > 0 ? safeVersions[0] : activeSafeVersion;
    }
    safeVersions.forEach(function(version) {
      if (version && version.versionRange === 'HEAD') return;
      versionOptions.push(
        <div key={'safe-version-' + version.version} className="grid__item col-1-1 phone--col-1-3">
          <label className="label--radio">
            <input
              type="radio"
              name={version.version}
              value={version.version}
              checked={version.version === activeSafeVersion}
              onChange={self.updateActiveSafeVersion}
            />
            <span className="react--radio" /> {version.version}
          </label>
        </div>
      );
    });
    if (isFetchingSafeVersionsAfterRange) {
      versionsHtml = <div />;
    } else if (safeVersions.length > 0) {
      versionsHtml = (
        <div className="grid__item col-1-1 mt-">
          <form className="grid max-height--400">{versionOptions}</form>
        </div>
      );
    } else {
      versionsHtml = (
        <div className="grid__item col-1-1 mt-">
          <p>No safe versions found</p>
        </div>
      );
    }
    return (
      <div className="grid grid--full col-1-1">
        <div className="grid__item col-3-4">
          <div className="font--h6 mb- inline-block bo-b--1 border-color--muted pb-">
            Safe versions
          </div>
        </div>
        {versionsHtml}
      </div>
    );
  }
}
function mapStateToProps(state) {
  return {
    artifactState: state.artifactState,
    routing: state.routing,
  };
}
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(artifactActions, dispatch),
  };
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ArtifactViewMainContentFixInfoSafeVersions);
